
import { ref, computed, defineComponent, PropType } from "vue";
import { SignData } from "@/types";
import { bananoUtil } from "@/util/banano";
import { storeUtil } from "@/store";
import AnimatedCheck from "@/components/UI/AnimatedCheck.vue";

export default defineComponent({
  name: "Sign",
  components: {
    AnimatedCheck,
  },
  props: {
    signData: {
      type: Object as PropType<SignData>,
      required: true,
    },
    remoteUrl: {
      type: String,
      required: false,
    },
    index: {
      type: Number,
      required: false,
    },
    hideAccountSelection: {
      type: Boolean,
      required: false,
    },
  },

  setup(props, { emit }) {
    const accounts = computed(storeUtil.getters.accounts);

    const selectedIndex = computed(() => {
      return props.index === undefined
        ? storeUtil.getters.lastUsedIndex()
        : props.index;
    });
    const selectedAccount = computed(() => accounts.value[selectedIndex.value]);

    const transactionSuccessful = ref(false);
    const transactionInProgress = ref(false);
    const sign = async () => {
      const index = selectedIndex.value;

      try {
        if (props.signData.type === "hash" && props.signData.hash) {
          const result = bananoUtil.signHash(
            props.signData.hash,
            storeUtil.getters.seed(),
            index
          );

          transactionSuccessful.value = true;
          emit("result", result);
        } else if (
          props.signData.type === "transaction" &&
          props.signData.transaction
        ) {
          transactionInProgress.value = true;

          const result = await bananoUtil.sendTransaction(
            props.signData.transaction,
            storeUtil.getters.seed(),
            index
          );

          transactionInProgress.value = false;
          transactionSuccessful.value = true;
          emit("result", result);
        }
      } catch (e) {
        emit("error", e);
        throw e;
      }

      storeUtil.mutations.setLastUsedIndex(index);
    };

    return {
      selectedIndex,
      selectedAccount,
      accounts,
      sign,
      transactionInProgress,
      transactionSuccessful,
    };
  },
});
